// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyState__container--1Qr","image":"EmptyState__image--3C1","title":"EmptyState__title--lHA","description":"EmptyState__description--3l-"};